import React,{useEffect} from 'react';
import './HomePage.css';
import TopAutoSlide from './TopAutoSlide';
import Products from './Products';
import PartnersCarousel from './PartnersCarousel';
import AboutSection from './AboutSection';


const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
<>
<div className="homepage">

 <TopAutoSlide/>
 <Products/>
 <PartnersCarousel/>
 <AboutSection/>
 
</div>
</>
  )
}

export default HomePage
